export const getLgaName = (lga) => {
  if (typeof lga === "string") {
    return lga;
  }

  return lga?.name || lga?.label || "";
};

export const normalizeLgaOption = (lga) => {
  if (typeof lga === "string") {
    return { name: lga, deliveryFee: null };
  }

  return {
    name: lga?.name || lga?.label || "",
    deliveryFee: lga?.deliveryFee != null ? Number(lga.deliveryFee) : null,
  };
};

export const getLgaOptions = (stateConfig) => {
  if (!stateConfig?.LGAs) {
    return [];
  }

  return stateConfig.LGAs.map(normalizeLgaOption).filter((lga) => lga.name);
};

export const getDeliveryFee = (deliveryLocations, selectedState, selectedLGA) => {
  const stateConfig = deliveryLocations?.[selectedState];

  if (!stateConfig) {
    return 0;
  }

  const matchedLGA = getLgaOptions(stateConfig).find((lga) => lga.name === selectedLGA);

  if (matchedLGA?.deliveryFee != null) {
    return matchedLGA.deliveryFee;
  }

  return 0;
};
